export type TransactionType =
  | 'stamps_added'
  | 'stamp_correction'
  | 'reward_unlocked'
  | 'reward_redeemed'
  | 'reward_restored'
  | 'referral_bonus'
  | 'reward_expired'
  | 'birthday_reward_unlocked'

export const CUSTOMER_ACTIVITY_TYPES: TransactionType[] = [
  'stamps_added',
  'stamp_correction',
  'reward_unlocked',
  'reward_redeemed',
  'reward_restored',
  'referral_bonus',
  'reward_expired',
  'birthday_reward_unlocked',
]

// Types shown in the History Activity tab (stamp-earning events, not the
// reward lifecycle) — excludes reward-lifecycle events shown in the Rewards
// tab. referral_bonus grants stamps, not a reward directly, so it stays here
// even though it can indirectly complete a card.
export const CUSTOMER_STAMP_TYPES: TransactionType[] = [
  'stamps_added',
  'stamp_correction',
  'referral_bonus',
]

// birthday_reward_unlocked grants a reward the same way reward_unlocked
// does (issues a rewards row via unlocked_transaction_id), just via a
// different trigger — grouped with the reward lifecycle here so the whole
// birthday-reward story (unlock → redeem) lives on one tab, matching where
// its redemption (birthdayRewardRedeemed) already shows.
export const CUSTOMER_REWARD_TYPES: TransactionType[] = [
  'reward_unlocked',
  'reward_redeemed',
  'reward_restored',
  'reward_expired',
  'birthday_reward_unlocked',
]

export interface Transaction {
  id: string
  member_id: string
  type: TransactionType
  stamps_delta: number
  rewards_delta: number
  reward_item_id: string | null
  receipt_id: string | null
  correction_reason: string | null
  correction_note: string | null
  corrects_transaction_id: string | null
  created_at: string
  reward_items: { name: Record<string, string>; programme: 'loyalty' | 'birthday' } | null
  // reward_unlocked never sets reward_item_id on the transaction itself — the
  // reward item lives on the rewards row it created instead, linked back via
  // rewards.unlocked_transaction_id. This is that reverse-embedded path; only
  // populated by queries that ask for it.
  rewards?: { reward_items: { name: Record<string, string>; programme: 'loyalty' | 'birthday' } | null }[] | null
}

export interface ActivityGroup {
  label: string
  entries: Transaction[]
}
